import { ExpenseClassEnum } from './ExpenseClass.enum';

const getCriteriaFromLocalStorage = (mode) => {
    const criteriaMapping = {
        [ExpenseClassEnum.IngestedCCTransaction]: 'pendingCCCriteria',
        [ExpenseClassEnum.Reimbursement]: 'expenseCriteria',
        [ExpenseClassEnum.Payment]: 'paymentCriteria',
        [ExpenseClassEnum.CreditCard]: 'creditCardCriteria',
        [ExpenseClassEnum.Vault]: 'vaultChargesCriteria',
    };
    const criteria = criteriaMapping[mode];
    const storedCriteria = localStorage.getItem(criteria);
    return storedCriteria ? JSON.parse(storedCriteria) : {};
};

export default getCriteriaFromLocalStorage;
